import type { CoachingCoacheeCohortModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort';
import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import { pageTitle } from 'ember-page-title';

interface CoachingCoacheeCohortSessionsSignature {
  Args: {
    model: CoachingCoacheeCohortModel;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Sessions"}}

  <div class="container my-3">
    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4"
    >
      <ul
        class="nav nav-pills bg-body rounded-pill p-1 shadow-sm d-inline-flex"
      >
        <li class="nav-item">
          <LinkTo
            @route="coaching.coach.sessions.index"
            class="nav-link rounded-pill px-4 fw-semibold"
          >Current</LinkTo>
        </li>
        <li class="nav-item">
          <LinkTo
            @route="coaching.coach.sessions.history"
            class="nav-link rounded-pill px-4 fw-semibold"
          >History</LinkTo>
        </li>
      </ul>
    </div>
  </div>

  {{outlet}}
</template> satisfies TOC<CoachingCoacheeCohortSessionsSignature>;
